module.exports = __webpack_public_path__ + "img/intro-common-voice-class.877ebea6.jpg";